// extracted by mini-css-extract-plugin
export var container = "styles-module--container--3b2cd";
export var fluid = "styles-module--fluid--bd843";
export var fullWidth = "styles-module--fullWidth--c2cdc";
export var noGap = "styles-module--noGap--8d9c6";
export var small = "styles-module--small--76ade";
export var whiteBg = "styles-module--whiteBg--1de09";